import { useMutation } from 'react-query';
import { AxiosError } from 'axios';

import { getPaymentStatusForCancel } from '@/api/payment';
import { GetPaymentStatusForCancelResponse } from '@/types/payment.type';

type UseGetPaymentStatusProps = {
  qrOrderId: string;
};

export const useGetPaymentStatusForCancel = ({
  qrOrderId,
}: UseGetPaymentStatusProps) => {
  const { mutateAsync, data, isLoading, isError, error, reset, isIdle } =
    useMutation<GetPaymentStatusForCancelResponse, AxiosError, void>(
      () => getPaymentStatusForCancel({ qrOrderId }),
      {
        retry: 1,
        onError: (error) => {
          console.error('Payment status fetch error:', error);
        },
      },
    );

  return {
    checkPaymentStatus: mutateAsync,
    paymentStatus: data,
    isLoading,
    isError,
    error,
    reset,
    isIdle,
  };
};
